import { Phone, Mail } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL, EMAIL_HREF } from "./Nav";

// Reusable dark contact block for CTA sections — replaces contact/quote forms
export default function ContactBlock({ variant = "dark", title, subtitle, testid = "contact-block" }) {
  const dark = variant === "dark";
  return (
    <div data-testid={testid} className={dark ? "text-white" : "text-[#060913]"}>
      {title && (
        <h3 className={`font-display text-3xl md:text-5xl leading-[0.95] tracking-tight ${dark ? "text-white" : "text-[#060913]"}`}>
          {title}
        </h3>
      )}
      {subtitle && (
        <p className={`mt-4 max-w-md text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-[#5C5F66]"}`}>
          {subtitle}
        </p>
      )}
      <div className="mt-8 space-y-5">
        <a
          href={PHONE_HREF}
          data-testid={`${testid}-phone`}
          className={`group flex items-center gap-4 border-t ${dark ? "border-white/20 hover:border-[#D92323]" : "border-black/20 hover:border-[#D92323]"} pt-5 transition-colors`}
        >
          <span className={`inline-flex items-center justify-center w-12 h-12 border ${dark ? "border-white/30 group-hover:border-[#D92323] group-hover:bg-[#D92323]" : "border-black/30 group-hover:border-[#D92323] group-hover:bg-[#D92323]"} transition-colors`}>
            <Phone size={18} strokeWidth={1.5} className={`${dark ? "text-white group-hover:text-white" : "text-[#060913] group-hover:text-white"}`} />
          </span>
          <div>
            <div className={`font-mono text-[10px] tracking-[0.24em] uppercase ${dark ? "text-white/60" : "text-[#5C5F66]"}`}>
              Call · 24 / 7 Dispatch
            </div>
            <div className={`font-display text-2xl md:text-3xl tracking-tight ${dark ? "group-hover:text-[#D92323]" : "group-hover:text-[#D92323]"} transition-colors`}>
              {PHONE}
            </div>
          </div>
        </a>

        <a
          href={EMAIL_HREF}
          data-testid={`${testid}-email`}
          className={`group flex items-center gap-4 border-t ${dark ? "border-white/20 hover:border-[#D92323]" : "border-black/20 hover:border-[#D92323]"} pt-5 transition-colors`}
        >
          <span className={`inline-flex items-center justify-center w-12 h-12 border ${dark ? "border-white/30 group-hover:border-[#D92323] group-hover:bg-[#D92323]" : "border-black/30 group-hover:border-[#D92323] group-hover:bg-[#D92323]"} transition-colors`}>
            <Mail size={18} strokeWidth={1.5} className={`${dark ? "text-white" : "text-[#060913] group-hover:text-white"}`} />
          </span>
          <div>
            <div className={`font-mono text-[10px] tracking-[0.24em] uppercase ${dark ? "text-white/60" : "text-[#5C5F66]"}`}>
              Email · Same-Day Response
            </div>
            <div className={`font-display text-2xl md:text-3xl tracking-tight ${dark ? "group-hover:text-[#D92323]" : "group-hover:text-[#D92323]"} transition-colors`}>
              {EMAIL}
            </div>
          </div>
        </a>
      </div>
    </div>
  );
}
